import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core'
import { OidcStore } from '@core/store/oidc/oidc.store'
import { Heading } from '@shared/components/heading/heading'

@Component({
  selector: 'bo-login',
  template: '<bo-heading titleText="MTR_TITLE_LOGIN" />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Heading],
})
export class Login implements OnInit {
  readonly #oidcStore = inject(OidcStore)

  ngOnInit() {
    this.#oidcStore.signInRedirect(undefined)
  }
}
